// exportCommitAPI.js - API service for export commit functionality
import { fetchWithAuth } from "../apiutil";

export const exportCommitAPI = {
  queueDownloadExportCommit: async (accessToken, caseId, clipId) => {
    return fetchWithAuth(
      `/api/cases/${caseId}/clips/${clipId}/export`,
      { method: "GET" },
      accessToken
    );
  },
};
